var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStudent3 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    viewBox: "0 0 18 18",
    fill: "current",
    stroke: "current",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96981 4.63769C7.20887 4.63769 5.78135 6.06521 5.78135 7.82615C5.78135 9.58709 7.20887 11.0146 8.96981 11.0146C10.7308 11.0146 12.1583 9.58709 12.1583 7.82615C12.1583 6.06521 10.7308 4.63769 8.96981 4.63769ZM4.50597 7.82615C4.50597 5.36084 6.5045 3.3623 8.96981 3.3623C11.4351 3.3623 13.4337 5.36084 13.4337 7.82615C13.4337 9.36233 12.6577 10.7173 11.4763 11.5204C11.8167 11.6538 12.1479 11.8129 12.4668 11.997C13.5818 12.6405 14.5077 13.5661 15.1517 14.6808C15.3279 14.9857 15.2235 15.3758 14.9185 15.552C14.6136 15.7281 14.2235 15.6237 14.0473 15.3188C13.5153 14.3979 12.7504 13.6332 11.8293 13.1016C10.9081 12.5699 9.86336 12.29 8.79984 12.29C7.73632 12.29 6.69152 12.5699 5.77041 13.1015C4.84929 13.6331 4.0843 14.3978 3.55227 15.3187C3.37609 15.6236 2.98605 15.728 2.6811 15.5518C2.37615 15.3757 2.27176 14.9856 2.44794 14.6807C3.09193 13.566 4.01792 12.6404 5.13288 11.9969C5.52072 11.7731 5.92668 11.5861 6.34541 11.4374C5.23059 10.6259 4.50597 9.31062 4.50597 7.82615Z",
    fill: "#67757F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStudent3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/student-3.035ebb23.svg";
export { ForwardRef as ReactComponent };